const MAX_LENGTH = 1024;

export const validateLength = (value: string) => {
  return value.length > MAX_LENGTH ?
  'Se till att detta fält inte har mer än 1024 tecken.' : value.length === 0 ?
  'Vänligen fyll i all information' : '';
};
